import { makeStyles } from '@material-ui/core';

export const workRequestCardStyles = makeStyles(theme => ({
    sections: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2.5),
    },
    section: {
        '&:not(:first-child)': {
            borderTop: `1px solid ${theme.palette.neutral.main}`,
            paddingTop: theme.spacing(2.5),
        },
    },
    sectionLabel: {
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0.6,
        textTransform: 'uppercase',
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(1.5),
    },
    inputRows: {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 700px)',
        gap: theme.spacing(2),
    },
    buttonRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
    },
    actionRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
    },
    field: {
        flex: 1,
        minWidth: 0,
        '& .MuiFormControl-root': {
            width: '100%',
        },
        '& fieldset': {
            border: 'none',
        },
        '& .MuiOutlinedInput-root': {
            minHeight: 44,
            height: 44,
            paddingTop: 0,
            paddingBottom: 0,
            alignItems: 'center',
            backgroundColor: theme.palette.background.default,
            borderRadius: theme.shape.borderRadius,
        },
        '& .MuiOutlinedInput-input': {
            paddingTop: 0,
            paddingBottom: 0,
        },
        '& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
            transform: 'translate(14px, 13px) scale(1)',
        },
        '& .MuiIconButton-root': {
            padding: theme.spacing(0.75),
        },
    },
    actionBtn: {
        width: 230,
        height: 44,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
}));
